<ng-container *ngIf="config?.generalSettings.chartType === 'list'; else chartView">
    <div class="table-scroll-container">
        <analytics-display-list [isLoading]="isLoading" [listData]="listDisplayData" [showTitle]="showTitle" [settings]="generalSettings" [title]="chartDetails.title" [showTitleFromDashboard]="true" [filter]="chartDetails.title"></analytics-display-list>
    </div>
</ng-container>
<ng-template #chartView>
    <analytics-base-chart [showTitle]="showTitle" [isLoading]="isLoading" [hasData]="hasData">
        <h5 title>{{ chartDetails.title }}</h5>
        <canvas *ngIf="hasData"
            baseChart
            [type]="chartType"
            [data]="chartData"
            [options]="chartOptions"
            [plugins]="chartPlugins"
            #chartCanvas>
        </canvas>
    </analytics-base-chart>
</ng-template>
